import React from 'react';
import { useEditorStore } from '../../stores/editorStore';
import { useSettingsStore } from '../../stores/settingsStore';

export const TopBar: React.FC = () => {
  const { currentEpisode, currentSectionIndex } = useEditorStore();
  const { settings } = useSettingsStore();
  
  const sections = currentEpisode?.sections || [];
  const currentSection = sections[currentSectionIndex];
  const title = currentSection?.title || currentSection?.type || currentEpisode?.showTitle || settings.showName;
  
  // Calculate content section number (only count 'content' type sections)
  const contentSectionNumber = currentSection?.type === 'content'
    ? sections.slice(0, currentSectionIndex).filter((s) => s.type === 'content').length + 1
    : null;

  return (
    <div className="h-36 bg-black/80 rounded-xl flex items-center justify-between px-0 flex-shrink-0">
      <div className="flex items-center gap-8">
        {contentSectionNumber && <span className="text-gray-400 text-6xl">#{contentSectionNumber}</span>}
        <h1 className="text-7xl font-semibold text-white">
          {title === 'intro' ? 'Introduction' : title === 'outro' ? 'Conclusion' : title}
        </h1>
      </div>
    </div>
  );
};

export const NextSectionIndicator: React.FC = () => {
  const { currentEpisode, currentSectionIndex } = useEditorStore();
  
  const sections = currentEpisode?.sections || [];
  const isLastSection = currentEpisode ? currentSectionIndex >= sections.length - 1 : true;
  const nextSectionIndex = currentSectionIndex + 1;
  const nextSectionData = sections[nextSectionIndex];
  
  // Calculate content section number (only count 'content' type sections)
  const nextContentSectionNumber = nextSectionData?.type === 'content'
    ? sections.slice(0, nextSectionIndex).filter((s) => s.type === 'content').length + 1
    : null;
  
  const nextSectionTitle = nextSectionData?.title || `Section ${nextContentSectionNumber || nextSectionIndex + 1}`;

  if (isLastSection) return null;

  return (
    <div className="flex items-center justify-end gap-4 text-gray-500 italic">
      <span className="text-5xl">Suivant :</span>
      {nextContentSectionNumber && <span className="text-5xl">#{nextContentSectionNumber}</span>}
      <span className="text-6xl font-semibold">{nextSectionTitle}</span>
    </div>
  );
};
